import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack
} from '@mui/material';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import { ArrowDown2 } from 'iconsax-react';
import ShitcoinsInfo from '../../../public/json/shitcoin/info.json';

const QuestionComponent = () => {
  const { matches } = useResponsive();

  return (
    <>
      <Box
        sx={{
          mb: matches({ xs: 10, lg: 38 }),
          mt: matches({ xs: 10, lg: 1.5 })
        }}
      >
        <Stack gap={1} itemScope itemType="https://schema.org/FAQPage">
          <Typography
            variant={matches({ xs: 'body1', lg: 'h4' })}
            weight="bold"
            component="h2"
            color="textColor.A30"
            textAlign="center"
            sx={{ pb: matches({ lg: 0, xs: 5 }) }}
          >
            سوالات متداول
          </Typography>
          <Typography
            color="textColor.A30"
            textAlign="center"
            sx={{
              display: matches({ xs: 'none', lg: 'block' }),
              pb: matches({ xs: 5, lg: 15 })
            }}
          >
            لیستی از پرسش و پاسخ‌های که شاید با آن مواجه شوید
          </Typography>

          <Stack direction="column" gap={3}>
            {ShitcoinsInfo?.faq.map((item, index: number) => (
              <Accordion
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                elevation={0}
                key={index}
                sx={{
                  background: '#1D2126'
                }}
              >
                <AccordionSummary
                  aria-controls={`panel1a-content${index}`}
                  expandIcon={<ArrowDown2 size="24" color="#ffffff" />}
                  id={`accordion-${index}`}
                >
                  <Typography
                    itemProp="name"
                    variant={matches({ lg: 'body1', xs: 'body3' })}
                    weight="bold"
                    component="h3"
                    color="textColor.A30"
                  >
                    {item.title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                  sx={{ justifyContent: 'start', pt: 0, pb: 3 }}
                >
                  <Typography
                    itemProp="text"
                    variant={matches({ lg: 'body2', xs: 'body3' })}
                    color="textColor.A30"
                  >
                    {item.description}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Stack>
        </Stack>
      </Box>
    </>
  );
};

export default QuestionComponent;
